<div class="sir-container" #container>
    <header class="sir-menu" #header>
        @if (logos().length) {
            <a [siriusLink]="siteRoot()" class="sir-logo" (linkSelect)="onMenuItemClicked(siteRoot(), $event)">
                @if (logos().length > 1) {
                    <img
                        class="sir-mobile"
                        [src]="logos()[0]"
                        [alt]="'navigation.logoAlt' | translate"
                        fetchpriority="high" />
                    <img
                        class="sir-desktop"
                        [src]="logos()[1]"
                        [alt]="'navigation.logoAlt' | translate"
                        fetchpriority="high" />
                } @else {
                    <img
                        class="sir-desktop"
                        [src]="logos()[0]"
                        [alt]="'navigation.logoAlt' | translate"
                        fetchpriority="high" />
                }
            </a>
        }
        <nav [attr.aria-label]="'navigation.primary' | translate">
            <ul class="sir-nav-list" #navList>
                @for (menuGroup of menuGroups(); track $index) {
                    <li class="sir-nav-item">
                        <a
                            [siriusLink]="menuGroup.link"
                            (linkSelect)="onMenuItemClicked(menuGroup.link, $event, $index)"
                            class="sir-nav-link sir-text-style-paragraph-m-bold"
                            [attr.aria-haspopup]="hasSubmenu(menuGroup) ? 'menu' : null"
                            [attr.aria-expanded]="hasSubmenu(menuGroup) ? isSubmenuOpen($index) : null"
                            (mouseenter)="onMouseEnter($index, $event); $event.preventDefault()"
                            (mouseleave)="onMouseLeave()"
                            >{{ menuGroup.title }}
                        </a>
                    </li>
                }
            </ul>
        </nav>
        <ul class="sir-right" [attr.aria-label]="'navigation.headerActions' | translate">
            @if (ctaButton()) {
                <li class="sir-right-item sir-right-item--cta">
                    <a
                        siriusButton
                        [size]="ctaButtonSize()"
                        buttonType="primary"
                        [siriusLink]="ctaButton()!"
                        [buttonText]="ctaButton()!.title"
                        class="sir-header-cta">
                    </a>
                </li>
            }
            @if (searchPageUrl()) {
                <li class="sir-right-item sir-right-item--search">
                    <div
                        id="header-search-panel"
                        tabindex="-1"
                        #searchContainer
                        class="sir-search-container"
                        role="search"
                        [attr.aria-label]="'page.search' | translate"
                        [style.top.px]="header.offsetHeight"
                        [class.sir-show]="isSearchBarOpen()">
                        <sirius-search [rounded]="true"></sirius-search>
                        <button
                            type="button"
                            class="sir-cancel-button"
                            siriusButton
                            size="small"
                            buttonType="primary"
                            [buttonText]="'button.cancel' | translate"
                            (click)="onSearchCancelClicked(false)"></button>
                    </div>
                    <button
                        type="button"
                        class="sir-search-toggle"
                        siriusButton
                        size="small"
                        iconName="magnifying_glass"
                        [attr.aria-expanded]="isSearchBarOpen()"
                        aria-controls="header-search-panel"
                        [attr.aria-label]="
                            (isSearchBarOpen() ? 'navigation.search.close' : 'navigation.search.open') | translate
                        "
                        (click)="onSearchIconClicked(!isSearchBarOpen())"></button>
                </li>
            }
            @if (profileEnabled()) {
                <li class="sir-right-item">
                    <sirius-profile-menu
                        [options]="profileMenuOptions()"
                        (profileMenuClicked)="onProfileMenuClicked($event)">
                    </sirius-profile-menu>
                </li>
            }
            @if (cartData()) {
                <li class="sir-right-item">
                    <a
                        siriusButton
                        size="small"
                        [siriusLink]="cartData()!.link"
                        buttonType="primary"
                        iconName="shopping_cart"
                        class="sir-menu-cart"
                        [attr.aria-label]="
                            cartData()!.totalCount > 0
                                ? ('navigation.cart.withCount' | translate: { count: cartData()!.totalCount })
                                : ('navigation.cart.label' | translate)
                        ">
                        @if (cartData()!.totalCount > 0) {
                            <sirius-badge
                                [count]="cartData()!.totalCount"
                                [color]="badgeColor.Secondary"
                                [fontBold]="true"
                                [size]="badgeSize.SM"
                                class="sir-menu-cart-badge"
                                aria-hidden="true">
                            </sirius-badge>
                        }
                    </a>
                </li>
            }
            <li class="sir-right-item">
                <button
                    type="button"
                    siriusButton
                    size="small"
                    iconName="list"
                    class="sir-menu-toggle"
                    aria-haspopup="menu"
                    [attr.aria-label]="'navigation.mobileMenu.open' | translate"
                    (click)="onMenuIconClicked()"></button>
            </li>
        </ul>
    </header>
</div>
